import React, { useContext, useState, useEffect } from "react";
import Footer from "../../component/footer/footer";
import Header from "../../component/header/header";
import Mobile from "../../component/mobile/mobile";
import favorite3 from "../../assets/favorite3.png";
import { LuDot } from "react-icons/lu";
import nursingservice1 from "../../assets/nursingservice1.png";
import nursingservice2 from "../../assets/nursingservice2.png";
import nursingservice3 from "../../assets/nursingservice3.png";
import "./Appointments.css";
import Breadcrumb from "../../component/breadcrumb/breadcrumb";
import { FaGreaterThan } from "react-icons/fa";
import { Bookingdetails } from "../../env/action";
import { UserContext } from "../../context/UserContext";

const Appointments = () => {
  const { token } = useContext(UserContext);
  const [bookingdetails, setBookingdetails] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!token) return;
    setLoading(true);
    Bookingdetails(token, (res) => {
      if (res.status === 1) {
        setBookingdetails(res.data);
      } else {
        console.log("No data found");
      }
      setLoading(false);
    });
  }, [token]);

  return (
    <>
      <Breadcrumb
        breadcrumbTitle="Appointments"
        breadcrumbNav={[
          {
            navText: "Home",
            path: "/",
          },
        ]}
      />
      <div className="container pt-3 mb-5">
        {loading ? (
          <p className="text-center">Loading...</p>
        ) : bookingdetails.length === 0 ? (
          <p
            className="text-center"
            style={{
              fontSize: "32px",
              fontWeight: "500",
              color: "#555",
              padding: "50px 0px 10px 0px",
            }}
          >
            No appointments found.
          </p>
        ) : (
          bookingdetails.map((booking, index) => (
            <div
              key={index}
              className="card mt-5 mb-5 p-3"
              style={{ backgroundColor: "#F8F8F8" }}
            >
              <div className="row">
                <div className="col-md-4">
                  <div
                    className="card text-white mb-3 d-flex sky-background-color"
                    style={{ height: "100%" }}
                  >
                    <div className="card-body d-flex justify-content-center align-items-center">
                      <img
                        src={booking.subservice_img}
                        className="img-fluid card-body-image"
                        alt="Service"
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-8">
                  <div className="card-body">
                    <div className="card-title d-flex justify-content-between">
                      <div className="d-flex"></div>
                    </div>
                    <table className="table table-borderless">
                      <tbody>
                        <tr>
                          <td scope="row">Service Name:</td>
                          <td>{booking.service_name}</td>
                        </tr>
                        <tr>
                          <td scope="row">Subservice Name:</td>
                          <td>{booking.subservice_name}</td>
                        </tr>
                        <tr>
                          <td scope="row"> Time Hour:</td>
                          <td>{booking.time_package}</td>
                        </tr>
                        <tr>
                          <td scope="row">Start Date:</td>
                          <td>{booking.start_date}</td>
                        </tr>
                        <tr>
                          <td scope="row">End Date:</td>
                          <td>{booking.end_date}</td>
                        </tr>
                        <tr>
                          <td scope="row">Order Address:</td>
                          <td>{booking.order_address}</td>
                        </tr>
                        <tr>
                          <td scope="row">Service Price:</td>
                          <td>{booking.service_price}</td>
                        </tr>
                        <tr>
                          <td scope="row">No Of Days:</td>
                          <td>{booking.no_of_days}</td>
                        </tr>
                        <tr>
                          <td scope="row">Total Amount:</td>
                          <td>{booking.total_amount}</td>
                        </tr>
                        <tr>
                          <td scope="row">Status:</td>
                          <td>
                            <button
                              className="btn border px-5 rounded-5 border-0"
                              style={{
                                color: "#FF9F2E",
                                backgroundColor: "#FFF1DC",
                              }}
                            >
                              {booking.status}
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          ))
        )}

        {/* <div className="mt-5">
          <nav data-pagination>
            <a href="#" disabled>
              <i className="ion-chevron-left" />
            </a>
            <ul>
              <li className="current">
                <a href="#1" className="text-white">
                  1
                </a>
              </li>
              <li>
                <a href="#2">2</a>
              </li>
              <li>
                <a href="#3">3</a>
              </li>
              <li>
                <a href="#4">4</a>
              </li>
              <li>
                <a href="#10">…</a>
              </li>
              <li>
                <a href="#25">25</a>
              </li>
            </ul>
            <a href="#2">
              <div className="btn border border-black rounded-0">
                Next
                <FaGreaterThan className="ms-2" />
              </div>
            </a>
          </nav>
        </div> */}
      </div>

      <Mobile />
    </>
  );
};

export default Appointments;
